import axios from "axios";
import { PagedResult } from "../models/paged-result";

export const OBRASOCIAL_URL = `ObraSocial`;

export const obrasocialServices = {
  getList: (queryParams: any) => {
    return axios.get<PagedResult>(`${OBRASOCIAL_URL}`, { params: queryParams });
  },
  getById: (id: string) => {
    return axios.get<any>(`${OBRASOCIAL_URL}/${id}`);
  },
  lookup: (queryParams?: any) => {
    return axios.get<any>(`${OBRASOCIAL_URL}/Lookup`, {
      // params: {
      //   ...queryParams,
      //   pageSize: 15,
      //   hiddeLoading: true,
      //   active: true,
      // },
    });
  },
};
